import vehiclesIndex from "@/modules/mobility/vehicles/store";
import vehicleModelsIndex from "@/modules/mobility/vehicleModels/store";
import fleetsIndex from "@/modules/mobility/fleets/store";
import documentationIndex from "@/modules/mobility/documentation/store";

export default { modules: [vehiclesIndex, vehicleModelsIndex, fleetsIndex, documentationIndex] };
